import React from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import { SortableTableHeaderNew } from './SortableTableHeader';
import PaginationControls from '../common/PaginationControls';
import DynamicInput from 'components/common/DynamicInput';

const DataTable = ({ data, columns }) => {
    const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow, canPreviousPage, canNextPage,
        pageOptions, pageCount, gotoPage, nextPage, previousPage, setPageSize, state: { pageIndex, pageSize },
    } = useTable( { columns, data, initialState: { pageIndex: 0 } }, useSortBy, usePagination);

    console.log(page)

    return (
        <>
            <table {...getTableProps()} style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()} key={`hg${headerGroup.id}`}>
                            {headerGroup.headers.map((column) => (
                                <SortableTableHeaderNew key={column.id} column={column}/>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()} key={row.id}>
                                {row.cells.map((cell) => (
                                    <td
                                        {...cell.getCellProps()}
                                        key={cell.column.id}
                                        style={{
                                            border: '1px solid #ddd',
                                            padding: '8px',
                                        }}
                                    >
                                        {typeof cell.value === 'object' && cell.value !== null ? 
                                            <DynamicInput value={cell.value} type={'jsonViewer'} onChange={undefined}/>
                                        : 
                                            cell.render('Cell')}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <PaginationControls
                pageIndex={pageIndex}
                pageCount={pageCount}
                pageSize={pageSize}
                setPageSize={setPageSize}
                canPreviousPage={canPreviousPage}
                canNextPage={canNextPage}
                previousPage={previousPage}
                nextPage={nextPage}
                gotoPage={gotoPage}
            />
        </>
    );
};

export default DataTable    ;
